import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {ListView} from './ListView';

/**
 * Composant qui encapsule une ListView dans un container scrollable.
 */
export class ScrollListView extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired, // Liste de items à afficher
    renderItem: PropTypes.func.isRequired, // Fonction retournant le rendu pour un item de la liste
    header: PropTypes.any, // Contenu se trouvant au dessus de la partie scrollable
    footer: PropTypes.any, // Contenu se trouvant en dessous de la partie scrollable
    scrollableHeader: PropTypes.any, // Contenu se trouvant dans la partie scrollable et au dessus la
                                     // liste
    scrollableFooter: PropTypes.any, // Contenu se trouvant dans la partie scrollable et en dessous la
                                     // liste

    className: PropTypes.any,
    headerClassName: PropTypes.any,
    footerClassName: PropTypes.any,
    scrollableClassName: PropTypes.any,
    onScrollBatch: PropTypes.func,
  };

  handleScroll = (event) => {
    const element = event.currentTarget;

    const isNearBottom =
      element.scrollTop + element.clientHeight >=
      element.scrollHeight - 200;

      if (this.props.onScrollBatch) {
        this.props.onScrollBatch();
      }
  };

  state = {};

  render() {
    const {
      className, scrollableClassName, scrollableHeader, scrollableFooter, ...other
    } = this.props;
    return (
      <div className={cn('ScrollListView', className)}
          style={this.props.showPrice ? { marginBottom: '2.5rem' } : {}}
          onScroll={this.handleScroll}
           ref={(_elt) => {if (!this.state.scrollableElement) this.setState({scrollableElement: _elt})}}>

        {/* Scrollable list */}
        <div className={cn('Scrollable', scrollableClassName)}>

          {scrollableHeader}

          {this.state.scrollableElement && (
            <ListView scrollableElement={this.state.scrollableElement} {...other}/>
          )}

          {scrollableFooter}

        </div>
        {this.props.seeMore &&
          <div className="see-more-combinations">
            <span className = "secondary2-text">
              {this.props.seeMoreCombinations}
            </span>
          </div>
        }
      </div>
    );
  }
}
